// extracted by mini-css-extract-plugin
export default {"root":"InvestorDetailPageBase_root__BJxWX"};